import ProcessWrapper from "./ProcessWrapper";
import ResultPopup from "./ResultPopup";
import PaymentProcess from "./ConnectProcess";
export var SberPay = {
  ProcessWrapper: ProcessWrapper,
  PaymentProcess: PaymentProcess,
  Result: ResultPopup
};